module.exports = __webpack_public_path__ + "method1.png?2094cf274b97fc6b15de452728dcf419";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/method1.png
// module id = 20
// module chunks = 0